/**
 * Created by vladislav on 11.02.2020
 */

const Round = function (rumble, players, winners) {
    this.rumble = rumble;
    this.players = players;
    this.id = rumble.rounds.length;

    this.winners = winners;
};

Round.prototype.isLast = function () {
    return this.id === 2;
};

Round.prototype.getOpponentId = function (id) {
    const index = this.players.indexOf(id);
    return this.players[index ^ 1];
};

Round.prototype.getOpponent = function (id) {
    const opponentId = this.getOpponentId(id);
    const opponent = this.rumble.players[opponentId];

    if (!opponent) {
        throw new Error(`no opponent for player ${id} ${opponentId
        } rumble players: ${Object.keys(this.rumble.players).join(", ")
        } round players: ${this.players.join(", ")}`);
    }

    return {
        id: opponentId,
        name: opponent.name,
        avatar: opponent.avatar
    };
};

Round.prototype.calcWinners = function (outcome) {
    this.winners = this.players.filter((id, pos) => pos % 2 === 0).map(function (player1) {
        const player2 = this.getOpponent(player1).id;

        if (player1 === Rumble.PLAYER_ID || player2 === Rumble.PLAYER_ID) {
            if (outcome === GameBase.OUTCOME_VICTORY) {
                return Rumble.PLAYER_ID;
            }

            return (player1 === Rumble.PLAYER_ID) ? player2 : player1;
        }

        return Math.random() < 0.5 ? player1 : player2;
    }, this);
};

Round.prototype.isWinner = function (playerId) {
    return this.winners.indexOf(playerId) !== -1;
};

Round.prototype.getInfo = function () {
    return {
        players: this.players,
        winners: this.winners
    };
};